import { useCallback } from 'react'
import {
  BadgeCheck,
  Bell,
  Sparkles,
  DoorOpen,
  AudioLines,
  Heart,
} from 'lucide-react'
import Link from 'next/link'

import { mxLogout, trackMxEvent } from '@/utils/mixpanel'
import useAuth from '@/hooks/useAuth'
import Avatar from '@/components/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuItemPlain,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const UserMenu = () => {
  const { isLoggedin, currentUser, logout } = useAuth()

  const onOpenChange = useCallback((open: boolean) => {
    if (!open) {
      return
    }
    trackMxEvent('Header User Menu Shown')
  }, [])

  const onLogout = useCallback(() => {
    mxLogout()
    logout()
  }, [ logout ])

  if (!isLoggedin || !currentUser) {
    return null
  }

  return (
    <DropdownMenu onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="p-0">
          <Avatar className="h-12 w-12" username={currentUser.username} />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="w-80 p-4">
          <div className="flex items-start gap-4">
            <Avatar className="h-14 w-14" username={currentUser.username} />
            <div className="grid flex-1 leading-tight">
              <span className="truncate text-lg font-bold">
                {currentUser.name}
              </span>
              <span className="mb-2 truncate text-sm font-normal">
                {currentUser.email}
              </span>
              <span className="mt-2">
                <DropdownMenuItemPlain asChild>
                  <Button variant="outline" size="xs" asChild>
                    <Link href={`/user/${currentUser.username}`}>
                      プロフィールを見る
                    </Link>
                  </Button>
                </DropdownMenuItemPlain>
              </span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link href="/my">
              <BadgeCheck size="20" />
              アカウント設定
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link href="/my/projects">
              <AudioLines size="20" />
              プロジェクト
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link href="/notifications">
              <Bell size="20" />
              お知らせ
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link href="/my/favorites">
              <Heart size="20" />
              お気に入り
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        {!currentUser.isProfessional && (
          <>
            <DropdownMenuGroup>
              <DropdownMenuItem asChild>
                <Link href="/register-pro">
                  <Sparkles />
                  クリエイターへ登録
                </Link>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onClick={onLogout} className="cursor-pointer">
          <DoorOpen size="20" />
          ログアウト
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UserMenu
